/** Ink and brush (fx 'brush', 'ink'): a dark stroke edged in blue, ink drops splashing. */
import { registerFx } from './registry';

const R = Math.random;

registerFx(['brush', 'ink'], (host) => ({
  skill: ({ src, tgt, s, style, sx, sy, tx, ty }) => {
    host.swingArc(src, style, s.fx === 'ink' ? '40,60,90' : '90,150,210', s.fx === 'ink' ? 1.3 : 1);
    const [cx, cy] = s.aoe || !tgt ? [sx, sy] : [tx, ty];
    if (s.fx === 'ink')
      host.fx.push({
        type: 'shock',
        x: cx,
        y: cy,
        t: 0,
        life: 0.6,
        r: (s.aoe ?? 2) * 26,
        col: '30,40,60',
      });
    for (let k = 0; k < (s.fx === 'ink' ? 30 : 12); k++) {
      const a = R() * Math.PI * 2;
      const sp = 40 + R() * 80;
      host.parts.push({
        x: cx,
        y: cy - 14,
        vx: Math.cos(a) * sp,
        vy: Math.sin(a) * sp * 0.6 - 30,
        g: 200,
        t: 0,
        life: 0.6,
        c: R() < 0.7 ? '#141820' : '#3a6a9a',
        s: 2,
      });
    }
    host.sfx.swing();
  },
}));
